import React from "react";
import { Box, Typography } from "@mui/material";
import {
  NoticeComposerAttachmentThumb,
  type NoticeComposerUploadedFile,
} from "./NoticeComposerAttachmentThumb";

type NoticeComposerAttachmentsGalleryProps = {
  files: NoticeComposerUploadedFile[];
  title?: string;
};

/** Grid of image/video previews for review and attachment steps. */
export const NoticeComposerAttachmentsGallery: React.FC<
  NoticeComposerAttachmentsGalleryProps
> = ({ files, title = "Attachments" }) => {
  if (files.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        {title} ({files.length})
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, minmax(0, 1fr))",
            sm: "repeat(3, minmax(0, 1fr))",
          },
          gap: 1.25,
        }}
      >
        {files.map((file, index) => (
          <Box
            key={`${file.fileUrl}-${index}`}
            sx={{
              borderRadius: 1.5,
              overflow: "hidden",
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
            }}
          >
            <Box sx={{ aspectRatio: "16 / 10", position: "relative" }}>
              <NoticeComposerAttachmentThumb
                file={file}
                variant="tile"
                showPlayHint={false}
              />
            </Box>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                px: 0.75,
                py: 0.5,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: "text.secondary",
              }}
              title={file.fileName}
            >
              {file.fileName}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NoticeComposerAttachmentsGallery;
